import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';

export function getEffectiveYears(): OptionType[] {
  const featureCreationYear = 2024; // A preset value only for Altus. Come up with a better solution if needed for other carriers.
  const finalEffectiveYear = new Date().getFullYear() + 1;
  const catalogYears = finalEffectiveYear - featureCreationYear;

  const options = [];

  for (let i = 0; i <= catalogYears; i += 1) {
    const year = (featureCreationYear + i).toString();
    options.push({ value: year, label: year });
  }

  return options;
}
